// extracted by mini-css-extract-plugin
export var filterIncDec = "_bs-0";
export var leftBorder = "_bs-1";
export var rightBorder = "_bs-2";
export var stringInput = "_bs-3";